export const BuildInfo = {timestamp:1783967367000}
